export class Client {
    patientId: number;
    lastName: string;
    firstName: string;
    serivceTypeId: number;
    serviceOrderId: any;
    visitStatus: number;
    arrivalDate: Date;
    departureDate: Date;
    arrivalTime: any;
    departureTime: any;
    duration: number;
    businessId: number;

 
   constructor(patientId: number, lastName: string,firstName: string, serviceTypeId: number, serviceOrderId: any, visitStatus: number, arrivalTime: Date, departureTime: Date, duration: number, businessId: number) {     
    this.patientId = patientId;
    this.lastName = lastName;
    this.firstName = firstName;    
    this.serivceTypeId = serviceTypeId;
    this.serviceOrderId = serviceOrderId;
    this.visitStatus = visitStatus;
    this.arrivalDate = arrivalTime;
    this.departureDate = departureTime;
    this.duration = duration;
    this.businessId = businessId;
  }
}